import React from 'react';
import { useTranslation } from 'react-i18next';
import { Container, Row, Col, Breadcrumb } from 'react-bootstrap';
import { Link } from 'react-router-dom';
import subBannerImg from '../assets/images/sub-banner-img.png';

const SubBanner = ({ title, breadcrumb }) => {
  const { t } = useTranslation();
  return (
    <section className="float-left w-100 sub-banner-con position-relative main-box">
      <Container>
        <Row className="align-items-center">
          <Col lg={7} md={7}>
            <div className="sub-banner-content-con">
              <h1>{t(title)}</h1>
              <p dangerouslySetInnerHTML={{ __html: t(`${breadcrumb}_subtitle`) }}></p>
              <div className="breadcrumb-con d-inline-block">
                <Breadcrumb>
                  <Breadcrumb.Item linkAs={Link} linkProps={{ to: "/" }}>{t('nav_home')}</Breadcrumb.Item>
                  <Breadcrumb.Item active>{t(breadcrumb)}</Breadcrumb.Item>
                </Breadcrumb>
              </div>
            </div>
          </Col>
          <Col lg={5} md={5}>
            <div className="sub-banner-img-con">
              <figure>
                <img src={subBannerImg} alt="robot" />
              </figure>
            </div>
          </Col>
        </Row>
      </Container>
    </section>
  );
};

export default SubBanner;